/* tslint:disable */
/* eslint-disable */
export enum WorkPaymentMethodTypeEnum {
  $23 = 23,
  $27 = 27,
  $33 = 33,
  $37 = 37,
  $43 = 43,
  $73 = 73,
  $77 = 77,
  $78 = 78,
  $80 = 80
}
